import { Component, Input } from '@angular/core';
import { BaseInquiryBubble } from '../../_models/base-inquiry-date';

@Component({
  selector: 'base-inquiry-bubble',
  templateUrl: './base-inquiry-bubble.component.html',
})
export class BaseInquiryBubbleComponent {
  @Input() bubble: BaseInquiryBubble;
  @Input() isShiftPlan = false;
}
